export const SECTOR_COORDS = {
  1: [16, 31], 2: [30, 23], 3: [53, 22], 4: [78, 31], 5: [88, 48],
  6: [71, 67], 7: [50, 67], 8: [25, 67], 9: [34, 47], 10: [58, 46],
};

export const ROUTES = {
  maritime: [[-8, 74], [13, 76], [34, 78], [58, 80], [82, 76], [108, 64]],
  road: [[15, 59], [29, 52], [45, 55], [60, 49], [78, 41], [94, 33]],
  belt: [[12, 45], [29, 38], [48, 34], [67, 37], [91, 46]],
  rail: [[21, 62], [34, 55], [51, 57], [68, 51], [88, 54]],
};

export const SKYLINE_ZONES = [
  { x: 43, y: 49, width: 13, height: 20, tone: 'city' },
  { x: 57, y: 42, width: 17, height: 28, tone: 'city' },
  { x: 71, y: 54, width: 12, height: 16, tone: 'industrial' },
  { x: 23, y: 51, width: 13, height: 18, tone: 'industrial' },
];

export const HARBOR_CRANES = [[14, 66], [18, 64], [22, 65], [76, 68], [82, 65]];

export const WEATHER_BANDS = [
  { x: 9, y: 18, width: 29, height: 10, speed: 0.008, opacity: 0.11 },
  { x: 52, y: 29, width: 34, height: 12, speed: -0.006, opacity: 0.08 },
  { x: 22, y: 82, width: 42, height: 9, speed: 0.004, opacity: 0.07 },
];

export const ISLAND = [[9, 45], [17, 31], [31, 24], [47, 20], [63, 23], [78, 30], [91, 42], [87, 57], [78, 69], [64, 77], [47, 79], [30, 75], [16, 65]];

export const AMBIENT_PRESETS = {
  dawn: { sky: ['#6c837f', '#17353b'], island: '#315d59', glow: '#ffd18d' },
  day: { sky: ['#6aa7a0', '#153d49'], island: '#2d645b', glow: '#ffe2a9' },
  dusk: { sky: ['#946d70', '#172c3c'], island: '#3e514b', glow: '#ffb36c' },
  night: { sky: ['#1d3550', '#08131f'], island: '#1e3c43', glow: '#88c6d1' },
};

export function pointAt(route, progress) {
  const segments = route.slice(0, -1).map((start, index) => {
    const end = route[index + 1];
    return { start, end, length: Math.hypot(end[0] - start[0], end[1] - start[1]) };
  });
  const total = segments.reduce((sum, segment) => sum + segment.length, 0);
  let distance = ((progress % 1) + 1) % 1 * total;
  for (const segment of segments) {
    if (distance <= segment.length) {
      const ratio = distance / segment.length;
      return [segment.start[0] + ((segment.end[0] - segment.start[0]) * ratio), segment.start[1] + ((segment.end[1] - segment.start[1]) * ratio)];
    }
    distance -= segment.length;
  }
  return route[route.length - 1];
}
